import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

function DigitalProducts() {
  // Updated products array with image properties and basket actions
  const products = [
    {
      id: 1,
      name: "Halloween clay cutter set",
      price: "£12.00",
      desc: "A small collection of Halloween themed clay cutter STL files to 3D print at home.",
      image: "https://via.placeholder.com/300x200?text=Clay+Cutter+Set", // Replace with your image URL or path
    },
    {
      id: 2,
      name: "Ghostface cutter STL file",
      price: "£8.50",
      desc: "This is a digital STL file to 3D print a Ghostface cutter at home.",
      image: "https://via.placeholder.com/300x200?text=3D+Printables",
    },
    {
      id: 3,
      name: "Skele-bat cutter STL file",
      price: "£5.00",
      desc: "This is a digital STL file to 3D print a Skele-Bat cutter at home.",
      image: "https://via.placeholder.com/300x200?text=Cricut+Projects",
    },
  ];

  const [hoveredButtonId, setHoveredButtonId] = useState(null);
  const [basketHovered, setBasketHovered] = useState(false);

  // Saves the clicked product into browser storage
  const handleAddToBasket = (product) => {
    const existingBasket = JSON.parse(localStorage.getItem("basket")) || [];
    const updatedBasket = [...existingBasket, product];
    localStorage.setItem("basket", JSON.stringify(updatedBasket));
    alert(`Added ${product.name} to your basket!`);
  };

  return (
    <div className="container" style={{ position: "relative" }}>
      {/* 🛒 Basket Button at the Top Right */}
      <Link
        to="/basket"
        onMouseEnter={() => setBasketHovered(true)}
        onMouseLeave={() => setBasketHovered(false)}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          backgroundColor: basketHovered ? "#8fa882" : "#c6a47e",
          color: "#2b2621",
          padding: "8px 16px",
          borderRadius: "12px",
          border: "2px solid #2b2621",
          fontWeight: "bold",
          textDecoration: "none",
          boxShadow: basketHovered ? "0 4px 0 #2b2621" : "0 2px 0 #2b2621",
          transform: basketHovered ? "translateY(-2px)" : "none",
          transition: "all 0.2s ease",
          zIndex: 10,
        }}
      >
        🛒 Basket
      </Link>

      {/* Page Header */}
      <div className="logo-area">
        <h1 className="main-title">Digital Products</h1>
      </div>

      <div
        className="welcome-badge"
        style={{
          display: "inline-block",
          fontSize: "1.2rem",
          padding: "6px 16px",
          borderRadius: "20px",
          marginBottom: "20px",
          fontWeight: "700",
        }}
      >
        Instant Downloads
      </div>

      <p className="prompt-text">Browse our collection of digital products.</p>

      {/* Product Grid */}
      <div
        className="product-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "25px",
          margin: "40px 0",
          textAlign: "left",
        }}
      >
        {products.map((product) => {
          const isHovered = hoveredButtonId === product.id;

          return (
            <div
              key={product.id}
              className="product-card"
              style={{
                backgroundColor: "#fffbf5",
                border: "3px solid #2b2621",
                borderRadius: "20px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 4px 0 #2b2621",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "180px",
                  backgroundColor: "#f0e6dc",
                  borderBottom: "3px solid #2b2621",
                }}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>

              <div
                style={{
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h3
                    style={{
                      fontSize: "1.4rem",
                      margin: "0 0 8px 0",
                      color: "#2b2621",
                    }}
                  >
                    {product.name}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#666",
                      margin: "0 0 15px 0",
                      minHeight: "40px",
                    }}
                  >
                    {product.desc}
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      color: "#2b2621",
                    }}
                  >
                    {product.price}
                  </span>

                  <button
                    className="btn"
                    onClick={() => handleAddToBasket(product)}
                    onMouseEnter={() => setHoveredButtonId(product.id)}
                    onMouseLeave={() => setHoveredButtonId(null)}
                    style={{
                      minWidth: "auto",
                      padding: "8px 14px",
                      fontSize: "0.9rem",
                      borderRadius: "12px",
                      transition: "all 0.2s ease",
                      backgroundColor: isHovered ? "#8fa882" : "#c6a47e",
                      color: "#2b2621",
                      border: "2px solid #2b2621",
                      cursor: "pointer",
                      transform: isHovered ? "translateY(-2px)" : "none",
                      boxShadow: isHovered
                        ? "0 3px 0 #2b2621"
                        : "0 1px 0 #2b2621",
                    }}
                  >
                    Add to basket
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: "50px" }}>
        <Link to="/" className="btn btn-wide">
          ← Back to Homepage
        </Link>
      </div>
    </div>
  );
}

export default DigitalProducts;
